import { ArcElement, Chart as ChartJS } from 'chart.js'
import React, { useMemo } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next'

import Text from '@/components-latest/primitives/Text'
import { OrdersPerformance } from '@/ducks/performance/performance.types'

import {
  compileChartData,
  compileLegendData,
  DEFAULT_OPTIONS
} from './helpers/OrdersDoughnut.helpers'
import Styles from './OrdersDoughnut.module.scss'

ChartJS.register(ArcElement)
const OrdersDoughnutChart: React.FC<{
  ordersPerformance: OrdersPerformance
}> = ({ ordersPerformance }) => {
  const data = useMemo(
    () => compileChartData(ordersPerformance),
    [ordersPerformance]
  )

  return <Doughnut options={DEFAULT_OPTIONS} data={data} />
}

const OrdersDoughnutLegend: React.FC<{
  ordersPerformance: OrdersPerformance
}> = ({ ordersPerformance }) => {
  const { t } = useTranslation()

  const data = useMemo(
    () => compileLegendData(ordersPerformance),
    [ordersPerformance]
  )

  return (
    <div>
      <Text variant="nextTitle-3" gutter={16}>
        {t('performance.doughnut.legend.title', { count: data.accepted })}
      </Text>
      <ul className={Styles.doughnutLegend}>
        {data.types.map(value => (
          <li className={Styles.legendItem} key={value.label}>
            <span
              style={{ backgroundColor: value.backgroundColor }}
              className={Styles.colorIcon}
            />
            <Text variant="nextSubtitle">
              {t(value.label)}
              <Text variant="nextSubtitle" weight="bold" asChild>
                <span> • {value.count} </span>
              </Text>
              ({Number(value.percentage).toFixed(1)}%)
            </Text>
          </li>
        ))}
      </ul>
    </div>
  )
}

const OrdersDoughnut = {
  Chart: OrdersDoughnutChart,
  Legend: OrdersDoughnutLegend
}
export default OrdersDoughnut
